import { ChangeDetectionStrategy, Component, ElementRef, inject, input, output } from '@angular/core';
import { ActivitySectionDirective, IMenuWithPages, MenuImageComponent } from '@core';
import { HeaderComponent, PageHeaderBackSwipeConfig } from '@app/components/header/header.component';
import { ScrollComponent } from '@app/components/scroll/scroll.component';
import { HeaderTextComponent } from '@app/components/header/header-text/header-text.component';

@Component({
  selector: 'app-page-pdf-menu-pages',
  templateUrl: './pdf-menu-pages.component.html',
  styleUrl: './pdf-menu-pages.component.scss',
  imports: [
    ActivitySectionDirective,
    HeaderComponent,
    MenuImageComponent,
    ScrollComponent,
    HeaderTextComponent,
  ],
  host: {
    class: 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdfMenuPagesComponent {

  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly backSwipeConfig: PageHeaderBackSwipeConfig = {
    element: this.elementRef.nativeElement,
  };

  public readonly back = output();

  public readonly menu = input.required<IMenuWithPages>();

}
